// src/pages/Clinique/cliniqueTourConfig.js

import i18n from "../../../i18n/config";

export const cliniqueTourSteps = [
	  {
	    popover: {
	      title: i18n.t("tours.clinics.welcome"),
	      description: i18n.t("tours.clinics.welcomeDesc"),
	      side: "over",
	    },
	  },
	  {
	    element: 'input[placeholder*="Search"]',
	    popover: {
	      title: i18n.t("tours.clinics.search"),
	      description: i18n.t("tours.clinics.searchDesc"),
	      position: "bottom",
	    },
	  },
	  {
	    element: ".clinique-list-scroll",
	    popover: {
	      title: i18n.t("tours.clinics.list"),
	      description: i18n.t("tours.clinics.listDesc"),
	      position: "top",
	    },
	  },
	  {
	    element: ".phc-row",
	    popover: {
	      title: i18n.t("tours.clinics.card"),
	      description: i18n.t("tours.clinics.cardDesc"),
	      position: "left",
	    },
	  },
	  {
	    popover: {
	      title: i18n.t("tours.clinics.done"),
	      description: i18n.t("tours.clinics.doneDesc"),
	      side: "over",
	    },
	  },
];